import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from '@mui/material';
import React, { useState } from 'react';

export default function SMSCreateSenderMenu({ open, setOpen, createNewSender, brand }) {
    const [sender, setSender] = useState('');
    const isValid = sender.length >= 2 && sender.length <= 11;

    return (
        <Dialog open={open}>
            <DialogTitle>Create Sender</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    required
                    margin="dense"
                    id="name"
                    name="senderName"
                    label="Sender Name"
                    type="text"
                    fullWidth
                    value={sender}
                    onChange={(e) => setSender(e.target.value)}
                    variant="standard"
                    error={sender.length > 0 && !isValid}
                    helperText={
                        sender.length > 0 && !isValid
                            ? 'Sender name must be between 2 and 11 characters.'
                            : ' '
                    }
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>Cancel</Button>
                <Button
                    onClick={() => createNewSender(brand, sender)}
                    disabled={!isValid}
                >
                    Create Sender
                </Button>
            </DialogActions>
        </Dialog>
    );
}
